
export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    USER: 'user',
} as const;

export const TOKEN_REFRESH_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutes

export const LOGOUT_ERROR_CODES = ['user_not_found', 'user_inactive', 'token_not_valid'];

export const AUTH_MESSAGES = {
    // Success
    register_success: '¡Registro exitoso! Por favor verifica tu correo.',
    resent_code: 'Código de confirmación reenviado.',
    email_confirmed: 'Correo verificado exitosamente.',
    email_confirmed_and_logged_in: 'Correo verificado. Has iniciado sesión.',
    email_sent: 'Correo enviado exitosamente.',
    password_reset_success: 'Contraseña actualizada exitosamente.',
    password_reset_request_success: 'Solicitud de restablecimiento enviada.',

    // Errors
    error: 'Ocurrió un error. Inténtalo de nuevo.',
    passwords_mismatch: 'Las contraseñas no coinciden.',
    bad_email: 'Correo electrónico inválido.',
    bad_data: 'Datos inválidos.',
    invalid_data: 'Enlace inválido o caducado.',
    wrong_data: 'Correo o contraseña incorrectos.',
    reset_psw: 'Por favor restablece tu contraseña.',
    account_block: 'Tu cuenta ha sido bloqueada.',
    invalid: 'Credenciales inválidas.',
} as const;
